import React from 'react'

const Curve = ({
  className = '',
  arcWidth = 2,
  color = {},
  value = 0
}) => {
  return (
    <div className={className}>
      <div className="chart-wrapper">
          <div className="arc" data-value={arcWidth} style={color}></div>
      </div>
      <div className="score" style={color}>{value}</div>
      </div>
    )
}

export default Curve



// WEBPACK FOOTER //
// ../app/components/common/charts/Curve.jsx